import z from 'zod';

import { UserId } from '../BrandedIds';
import { zodJSInstantDate } from '../dates/BrandedDate';

export const AuditLogHiddenData = z.object({
  hiddenBy: UserId,
  hiddenAt: zodJSInstantDate,
  comment: z.string(),
});
export type AuditLogHiddenData = z.infer<typeof AuditLogHiddenData>;
